export default {"src":"/_next/static/media/36-icon.4ff5ab76.svg","height":46,"width":36,"blurWidth":0,"blurHeight":0};